import React from "react";
import { Box } from "@mui/material";

export default function ChartSkeleton({ height = 200 }) {
  return <Box className="dash-skeleton" sx={{ height, width: "100%" }} />;
}
